export const unitedStatesStateOptions = [
  { name: "Alabama", ID: "AL" },
  { name: "Alaska", ID: "AK" },
  { name: "Arizona", ID: "AZ" },
  { name: "Arkansas", ID: "AR" },
  { name: "California", ID: "CA" },
  { name: "Colorado", ID: "CO" },
  { name: "Connecticut", ID: "CT" },
  { name: "Delaware", ID: "DE" },
  { name: "District of Columbia", ID: "DC" },
  { name: "Florida", ID: "FL" },
  { name: "Georgia", ID: "GA" },
  { name: "Hawaii", ID: "HI" },
  { name: "Idaho", ID: "ID" },
  { name: "Illinois", ID: "IL" },
  { name: "Indiana", ID: "IN" },
  { name: "Iowa", ID: "IA" },
  { name: "Kansas", ID: "KS" },
  { name: "Kentucky", ID: "KY" },
  { name: "Louisiana", ID: "LA" },
  { name: "Maine", ID: "ME" },
  { name: "Maryland", ID: "MD" },
  { name: "Massachusetts", ID: "MA" },
  { name: "Michigan", ID: "MI" },
  { name: "Minnesota", ID: "MN" },
  { name: "Mississippi", ID: "MS" },
  { name: "Missouri", ID: "MO" },
  { name: "Montana", ID: "MT" },
  { name: "Nebraska", ID: "NE" },
  { name: "Nevada", ID: "NV" },
  { name: "New Hampshire", ID: "NH" },
  { name: "New Jersey", ID: "NJ" },
  { name: "New Mexico", ID: "NM" },
  { name: "New York", ID: "NY" },
  { name: "North Carolina", ID: "NC" },
  { name: "North Dakota", ID: "ND" },
  { name: "Ohio", ID: "OH" },
  { name: "Oklahoma", ID: "OK" },
  { name: "Oregon", ID: "OR" },
  { name: "Pennsylvania", ID: "PA" },
  { name: "Puerto Rico", ID: "PR" },
  { name: "Rhode Island", ID: "RI" },
  { name: "South Carolina", ID: "SC" },
  { name: "South Dakota", ID: "SD" },
  { name: "Tennessee", ID: "TN" },
  { name: "Texas", ID: "TX" },
  { name: "Utah", ID: "UT" },
  { name: "Vermont", ID: "VT" },
  { name: "Virginia", ID: "VA" },
  { name: "Washington", ID: "WA" },
  { name: "West Virginia", ID: "WV" },
  { name: "Wisconsin", ID: "WI" },
  { name: "Wyoming", ID: "WY" },
];
